// src/Demos/DepreciationDemo.js
import React from "react";
import CoordinatePlane from "../MathTools/CoordinatePlane";

/**
 * DepreciationDemo
 *
 * Plots how an item value decreases each year at a rate d.
 *    Value(t) = initialValue * (1−d)^t
 *
 * Props:
 *   initialValue=20000
 *   depreciationRate=0.10  (10% per year)
 *   years=5
 *   width,height
 */
export default function DepreciationDemo({
  initialValue=20000,
  depreciationRate=0.10,
  years=5,
  width=400,
  height=300
}) {
  const lines = [];
  let minVal=Infinity, maxVal=0;

  for (let y=0; y<=years; y++){
    const val = initialValue * Math.pow((1 - depreciationRate), y);
    if (val>maxVal) maxVal=val;
    if (val<minVal) minVal=val;

    lines.push({
      start:[y,val],
      end:[y,val],
      color:"red",
      label:`Year ${y}: $${val.toFixed(2)}`
    });
  }

  // x from 0..(years+1), y from 0..(some margin above initialValue)
  const xDomain = [0, years+1];
  const yDomain = [0, maxVal * 1.1]; // top ~ initialValue plus margin

  // xTick => 0..(years+1)
  const xTicks=[];
  for (let i=0; i<=years+1; i++){
    xTicks.push(i);
  }

  return(
    <div style={{ margin:"1em 0"}}>
      <h5>Depreciation Demo</h5>
      <CoordinatePlane
        width={width}
        height={height}
        lines={lines}
        showAxes={true}
        axisMode="border"
        disablePlot={true}
        xDomain={xDomain}
        yDomain={yDomain}
        xTickValues={xTicks}
        style={{ margin:"0 auto", display:"block"}}
      />
      <p style={{ fontSize:"0.9em", fontStyle:"italic", marginTop:8}}>
        Value decreases from $ {initialValue} at { (depreciationRate*100).toFixed(1)}% each year,
        after {years} years it's about $ {lines[lines.length-1].start[1].toFixed(2)}.
      </p>
    </div>
  );
}
